module.exports = __webpack_public_path__ + "static/media/K-Diamond.15365639.svg";